var player = null;
document.addEventListener('DOMContentLoaded', function() {
    var videoElement = document.getElementById('vid1');

    if (videoElement) {

        player = videojs('vid1', {
            playbackRates: [0.5, 1, 1.5, 2],
            controls: true,
            fluid: true,
            playsinline: true,
            responsive: true,
            enableSmoothSeeking: true,
            enableDocumentPictureInPicture : true
        });

        var videoDetailElement = document.getElementById('videoDetails');

        var localeFull = videoDetailElement.getAttribute('data-locale');
        var locale = localeFull.split('-')[0];

        var dataSrcValue = atob(videoDetailElement.getAttribute('data-src'));
        var subtitles = videoDetailElement.getAttribute('data-tracks');

        const extension = getFileExtension(dataSrcValue);
        player.src({type: 'video/'+extension, src: dataSrcValue});

        if (subtitles) {
            subtitles =  atob(subtitles);
            var decodedSubtitles = decodeURIComponent(subtitles);
            var subtitlesObject = JSON.parse(decodedSubtitles);
            Object.keys(subtitlesObject).forEach(function (lang) {
                var trackInfo = subtitlesObject[lang];
                //console.log(trackInfo.label);
                player.addRemoteTextTrack({
                    kind: 'captions',
                    src: trackInfo.src,
                    srclang: lang,
                    label: trackInfo.label,
                    default: lang === locale
                });
            });
        }

        const urlParams = new URLSearchParams(window.location.search);
        const startTimeParam = urlParams.get('start');
        const fullscreenParam = urlParams.get('fullscreen');

        player.ready(function() {
            var controlBar = player.controlBar;
            var playButton = controlBar.getChild('playToggle').el();

            var rewindButton = document.createElement('button');
            rewindButton.innerHTML = '<i class="test-01 fa-solid fa-arrow-rotate-left fa-lg"></i>';
            rewindButton.className = 'vjs-button vjs-control';
            rewindButton.onclick = function() {
                var currentTime = player.currentTime();
                player.currentTime(Math.max(0, currentTime - 10));
            };

            var forwardButton = document.createElement('button');
            forwardButton.innerHTML = '<i class="fa-solid fa-arrow-rotate-right fa-lg"></i>';
            forwardButton.className = 'vjs-button vjs-control';
            forwardButton.onclick = function() {
                var currentTime = player.currentTime();
                player.currentTime(Math.min(player.duration(), currentTime + 10));
            };

            controlBar.el().insertBefore(rewindButton, playButton);

            if (playButton.nextSibling) {
                controlBar.el().insertBefore(forwardButton, playButton.nextSibling);
            } else {
                controlBar.el().appendChild(forwardButton);
            }

            if (startTimeParam) {
                const startTime = parseFloat(startTimeParam);
                if (!isNaN(startTime)) {
                    player.currentTime(startTime);
                }
            }
 
            player.play().catch(function(error) {
                console.warn('Automatic reproduction was blocked:', error);
            });

            if (fullscreenParam === 'true') { 
                player.one('play', function() {
                    player.requestFullscreen();
                });
            }

        });
        videoElement.addEventListener('contextmenu', function(e) {
            e.preventDefault();
        }, false);
    }
});

window.setVideoTime = function (lang = '', timeText = '') {
    if(player) {
        var tracks = player.textTracks();
        for (var i = 0; i < tracks.length; i++) {
            var track = tracks[i];
            if (track.language === lang) {
                track.mode = 'showing';
            } else {
                track.mode = 'disabled';
            }
        }
        var timeText = timeText.trim();
        var startTime = convertTimeToSeconds(timeText);
        if (!isNaN(startTime)) {
            if ('pictureInPictureEnabled' in document) {
                if(typeof documentPictureInPicture !== 'undefined') {
                    if (!documentPictureInPicture.window) {
                        player.requestPictureInPicture();
                    }
                }else{
                    player.requestPictureInPicture();
                }
            }
            player.currentTime(startTime);
            player.play();
        }
    }
}

// Function to convert time in format (hh:mm:ss) to seconds
window.convertTimeToSeconds = function (timeText) {
    var parts = timeText.replace(/[()]/g, "").split(":");
    var hours = parseInt(parts[0], 10) || 0;
    var minutes = parseInt(parts[1], 10) || 0;
    var seconds = parseInt(parts[2], 10) || 0;

    return hours * 3600 + minutes * 60 + seconds;
}

window.getFileExtension = function (url) {
    const pathWithoutQuery = url.split('?')[0];
    const extension = pathWithoutQuery.split('.').pop();
    return extension.toLowerCase(); 
}
